import { __decorate } from "tslib";
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import JsxComponent from '@slickdeals/blueprint-twig/javascript/core/jsxComponent';
import CashbackSearchResultsBanner from '../patterns/cashbackSearchResultsBanner';
// The name of the module
export const name = 'CashbackSearchResultsBannerService';
let CashbackSearchResultsBannerService = class CashbackSearchResultsBannerService {
    initializeBanner(bannerProps) {
        return (JsxComponent.parseJsx(CashbackSearchResultsBanner, { cashbackRate: bannerProps.cashbackRate, ctaText: bannerProps.ctaText, ctaUrl: bannerProps.ctaUrl, storeName: bannerProps.storeName, trackingKey: bannerProps.trackingKey, testVariant: bannerProps.testVariant }));
    }
};
CashbackSearchResultsBannerService = __decorate([
    injectable(name)
], CashbackSearchResultsBannerService);
export default CashbackSearchResultsBannerService;
